import { Link } from "react-router-dom";
import { FileText, FileAudio, FileVideo, AlignLeft, ArrowRight, Trash2, Link2 } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { formatDate } from "../lib/constants";

const iconFor = (c) => {
  if (c.tipo === "testo") return AlignLeft;
  if (c.tipo === "link") return Link2;
  if (c.file_kind === "pdf") return FileText;
  if (c.file_kind === "video") return FileVideo;
  return FileAudio;
};

export const ContentList = ({ items, onDelete, emptyText = "Nessun contenuto ancora caricato." }) => {
  if (!items.length) {
    return (
      <div data-testid="content-list-empty" className="surface p-10 text-center text-sm text-muted-foreground">
        {emptyText}
      </div>
    );
  }
  return (
    <ul data-testid="content-list" className="stagger space-y-2">
      {items.map((c) => {
        const Icon = iconFor(c);
        return (
          <li key={c.id} data-testid={`content-row-${c.id}`} className="surface surface-hover group flex items-center gap-4 p-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary text-muted-foreground max-sm:hidden">
              <Icon className="h-5 w-5" />
            </div>
            <Link to={`/contenuti/${c.id}`} className="min-w-0 flex-1" data-testid={`content-link-${c.id}`}>
              <p className="truncate text-sm font-semibold">{c.titolo}</p>
              <p className="truncate text-xs text-muted-foreground">
                {formatDate(c.created_at)}{c.platform ? ` · ${c.platform}` : ""}{c.profile_title ? ` · profilo ${c.profile_title}` : ""} · {c.knowledge_count || 0} conoscenze
                {c.preview ? ` · ${c.preview}` : ""}
              </p>
              <StatusBadge stato={c.stato} className="mt-2 sm:hidden" />
            </Link>
            <StatusBadge stato={c.stato} className="hidden sm:inline-flex" />
            {onDelete && (
              <button
                data-testid={`content-delete-${c.id}`}
                onClick={() => onDelete(c)}
                className="rounded-md p-2 text-muted-foreground transition-opacity hover:bg-secondary hover:text-red-400 sm:opacity-0 sm:group-hover:opacity-100"
                title="Elimina"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            )}
            <Link to={`/contenuti/${c.id}`} className="text-muted-foreground transition-transform group-hover:translate-x-1">
              <ArrowRight className="h-4 w-4" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
